import { useEffect, useRef, useState } from 'react'
import renderPrgImage from '../../../source/programImg'
import styles from './LeftTrainingClass.module.css'
import { connect } from 'react-redux'
import { useIndexedDB } from 'react-indexed-db'
import { SpectrogramThumbnail } from './audioModel/Spectrogram'

function LeftTrainingClass(props) {
    const {
        jsPlumbInstanceRef,
        obj,
        webCamModelOpen,
        audioModelOpen = () => {},
        isAudioTrain,
        changeClasses,
        classesObjectKey,
        setClasses,
        isShowClassDeleteBtn,
        camModels,
        currentModelId,
        setAudioUploadOpen,
        detectionType,
        isSyncing,
    } = props
    const [className, setClassName] = useState(obj.className)
    const [classNameError, setClassNameError] = useState('')
    const [isClassEdit, setIsClassEdit] = useState({
        isEdit: false,
        prevClassname: '',
    })
    const [categoryName, setCategoryName] = useState(obj.CategoryName || 'Undefined')
    const [isCategoryEdit, setIsCategoryEdit] = useState({
        isEdit: false,
        prevCategoryName: 'Undefined',
    })
    const [capturedSamples, setCapturedSamples] = useState([])

    const { getAll, deleteRecord, add } = useIndexedDB('SavedFaces')
    const samplesDb = useIndexedDB('Samples')

    // Select classes based on sample type (image or audio)
    const isAudioClass = obj.sampleType === 'Audio'
    const currentModelData = camModels?.find(
        (model) => model?.modelId === currentModelId
    )
    const classes = isAudioClass
        ? currentModelData?.AudioClasses
        : currentModelData?.ImageClasses

    const isBgNoise = obj.className === 'Background_Noise'

    useEffect(() => {
        loadSamples()
    }, [
        currentModelId,
        classesObjectKey,
        classes,
        classes?.[classesObjectKey]?.capturedAudioCount,
        classes?.[classesObjectKey]?.capturedImagesCount,
    ])

    useEffect(() => {
        setCategoryName(obj.CategoryName || 'Undefined')
        setClassName(obj.className)
    }, [obj.CategoryName, obj.className])

    const loadSamples = async () => {
        try {
            const allSamples = await samplesDb.getAll()
            const filteredSamples = allSamples.filter(
                (sample) =>
                    sample.modelId === currentModelId &&
                    sample.classId === classesObjectKey &&
                    (isAudioTrain
                        ? sample.sampleType !== 'Image'
                        : sample.sampleType === 'Image')
            )
            setCapturedSamples(filteredSamples)
        } catch (error) {
            console.error('Error loading samples from IndexedDB:', error)
        }
    }

    // Validation function
    const validateClassName = (name) => {
        const trimmed = name.trim()
        const regex = /^[a-zA-Z0-9_ ]+$/
        if (trimmed.length > 15) return 'Class name must be max 15 characters'
        if (!regex.test(trimmed))
            return 'Special characters or newlines are not allowed'

        const currentModel = camModels.find(
            (model) => model.modelId === currentModelId
        )

        // Check the appropriate class type (audio or image)
        const classesToCheck = isAudioClass
            ? currentModel.AudioClasses
            : currentModel.ImageClasses
        const exists = Object.values(classesToCheck).some(
            (cls) =>
                cls.className.trim().toLowerCase() === trimmed.toLowerCase() &&
                cls.id !== obj.id
        )
        if (exists) return 'Class name already exists'
        return ''
    }

    const handleChangeClassName = (e) => {
        try {
            e.preventDefault()

            const err = validateClassName(className)
            if (err) {
                setClassNameError(err)
                setTimeout(() => setClassNameError(''), 2000)
                return
            }
            let newClasses = { ...classes }
            newClasses[classesObjectKey] = {
                ...obj,
                className: className.trim(),
            }

            if (isClassEdit.prevClassname !== className.trim()) {
                updateIndexDB(
                    newClasses[classesObjectKey]?.id,
                    className.trim()
                )
            }

            setIsClassEdit({ isEdit: false, prevClassname: '' })
            let classType = isAudioTrain ? 'AudioClasses' : 'ImageClasses'

            changeClasses({ data: newClasses, classType })
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    // setting the class category as human or non-human once the recording the samples is done
    const handleChangeCategoryName = (e, val) => {
        try {
            if (e && e.preventDefault) e.preventDefault()

            const valueToUse = val !== undefined ? val : categoryName
            const trimmed = valueToUse.trim()
            const regex = /^[a-zA-Z0-9_ ]+$/
            let err = ''
            if (trimmed.length > 15)
                err = 'Category name must be max 15 characters'
            else if (!regex.test(trimmed))
                err = 'Special characters or newlines are not allowed'

            if (err) {
                setClassNameError(err)
                setTimeout(() => setClassNameError(''), 2000)
                return
            }

            const classCategory = trimmed === 'Human' ? 'speaker' : 'Non Human'
            let newClasses = { ...classes }
            newClasses[classesObjectKey] = {
                ...obj,
                CategoryName: trimmed,
                classCategory,
            }

            setIsCategoryEdit({ isEdit: false, prevCategoryName: '' })
            let classType = isAudioTrain ? 'AudioClasses' : 'ImageClasses'

            changeClasses({ data: newClasses, classType })
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    const deleteFromIndexDB = (id) => {
        deleteRecord(id)
            .then(() => {
                console.log(`Record with ID '${id}' has been deleted.`)
            })
            .catch((error) => {
                console.error('Error deleting record:', error)
            })
    }

    const updateIndexDB = async (id, newClassName) => {
        try {
            let records = await getAll()
            const record = records.find((item) => item.id === id)
            if (record) {
                const newData = { ...record, className: newClassName }
                await deleteRecord(id)
                await add(newData)
            }
        } catch (e) {
            console.log('ERROR', e)
        }
    }

    const handleClassDelete = async () => {
        try {
            if (!isShowClassDeleteBtn || isBgNoise) {
                return
            }
            if (Object.keys(classes).length <= 1) {
                return
            }

            // Delete samples associated with this class
            const allSamples = await samplesDb.getAll()
            const samplesToDelete = allSamples.filter(
                (s) =>
                    s.modelId === currentModelId &&
                    s.classId === classesObjectKey
            )
            for (const s of samplesToDelete) {
                await samplesDb.deleteRecord(s.id)
            }

            let newClasses = { ...classes }
            const leftDivId = `train_left-div-${obj.id}`
            try {
                jsPlumbInstanceRef?.current?.deleteConnectionsForElement(
                    leftDivId
                )
            } catch (err) {}

            let classType = isAudioTrain ? 'AudioClasses' : 'ImageClasses'
            deleteFromIndexDB(newClasses[classesObjectKey]?.id)
            delete newClasses[classesObjectKey]
            changeClasses({ data: newClasses, classType })
        } catch (e) {
            console.error('ERROR', e)
        }
    }

    const handleRemoveSamples = async () => {
        try {
            // Delete samples from IndexedDB
            const allSamples = await samplesDb.getAll()
            const samplesToDelete = allSamples.filter(
                (s) =>
                    s.modelId === currentModelId &&
                    s.classId === classesObjectKey
            )
            for (const s of samplesToDelete) {
                await samplesDb.deleteRecord(s.id)
            }

            let selectedClassDetails = { ...obj }
            if (isAudioTrain) {
                selectedClassDetails.capturedAudio = []
                selectedClassDetails.capturedAudioCount = 0
            } else {
                selectedClassDetails.capturedImages = []
                selectedClassDetails.capturedImagesCount = 0
            }
            let classType = isAudioTrain ? 'AudioClasses' : 'ImageClasses'
            setClasses({
                key: classesObjectKey,
                data: selectedClassDetails,
                classType: classType,
            })
            setCapturedSamples([])
        } catch (error) {
            console.error('ERROR', error)
        }
    }

    const removeSingleSample = async (index, sampleId) => {
        try {
            if (sampleId) {
                await samplesDb.deleteRecord(sampleId)
            }

            let selectedClassDetails = { ...obj }
            if (isAudioTrain) {
                let audioArr = [...(selectedClassDetails.capturedAudio || [])]
                audioArr.splice(index, 1)
                selectedClassDetails.capturedAudio = audioArr
                selectedClassDetails.capturedAudioCount = audioArr.length
            } else {
                let imgArr = [...(selectedClassDetails.capturedImages || [])]
                imgArr.splice(index, 1)
                selectedClassDetails.capturedImages = imgArr
                selectedClassDetails.capturedImagesCount = imgArr.length
            }
            let classType = isAudioTrain ? 'AudioClasses' : 'ImageClasses'
            setClasses({
                key: classesObjectKey,
                data: selectedClassDetails,
                classType: classType,
            })
            loadSamples()
        } catch (error) {
            console.error('ERROR', error)
        }
    }

    const containerRef = useRef(null)
    const samplesToShow = capturedSamples

    return (
        <div>
            <div className={styles.trainClassHeader}>
                <div style={{ display:'flex', gap:'10px', alignItems:'center'}}>
                    <div className={styles.trainClassNameDiv}>
                        {isClassEdit.isEdit ? (
                            <form onSubmit={handleChangeClassName}>
                                <input
                                    className={styles.classnameInput}
                                    value={className}
                                    placeholder="Enter The Class Name"
                                    onChange={(e) => setClassName(e.target.value)}
                                    onBlur={handleChangeClassName}
                                />
                                {classNameError && (
                                    <p className={styles.classNameInputError}>
                                        {classNameError}
                                    </p>
                                )}
                            </form>
                        ) : (
                            <>
                                <p
                                    style={{
                                        marginBottom: '0',
                                        marginRight: '8px',
                                    }}
                                >
                                    {obj.className}{' '}
                                </p>
                                {!isBgNoise && className !== "Background_Noise" && (
                                    <div style={{ position: 'relative' }}>
                                        <img
                                            id={styles.editPencilImg}
                                            width={'28px'}
                                            style={{ cursor: 'pointer' }}
                                            src={renderPrgImage('editPencil')}
                                            alt="edit class name"
                                            onClick={() =>
                                                setIsClassEdit({
                                                    isEdit: true,
                                                    prevClassname: className,
                                                })
                                            }
                                        />
                                        <div
                                            className={`${styles.tooltipDiv} ${styles.pencilToolTip}`}
                                        >
                                            Edit Class Name
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    {className != "Background_Noise" && categoryName !== 'Undefined' &&
                    <div className={styles.trainClassNameDiv}>
                        {isCategoryEdit.isEdit ? (
                            <form onSubmit={handleChangeCategoryName}  style={{position: 'relative'}}>
                                <select
                                    className={styles.classnameInput}
                                    style={{
                                    font: 'Halcyon Regular',
                                    fontFamily: 'Halcyon Regular',
                                    fontSize: '15px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                }}
                                    value={categoryName}
                                    placeholder="Human or Non Human"
                                    onChange={(e) => {
                                        setCategoryName(e.target.value)
                                        handleChangeCategoryName(e, e.target.value)
                                    }}

                                >
                                <option value="Human">Human</option>
                                <option value="Non Human">Non-Human</option>
                                </select>
                            </form>
                        ) : (
                            <>
                                <p
                                    style={{
                                        marginBottom: '0',
                                        marginRight: '8px',
                                    }}
                                >
                                    {obj.CategoryName}{' '}
                                </p>
                                {!isBgNoise && (
                                    <div style={{ position: 'relative' }}>
                                        <img
                                            id={styles.editPencilImg}
                                            width={'28px'}
                                            style={{ cursor: 'pointer' }}
                                            src={renderPrgImage('editPencil')}
                                            alt="edit CategoryName"
                                            onClick={() =>
                                                setIsCategoryEdit({
                                                    isEdit: true,
                                                    prevCategoryName: obj.CategoryName,
                                                })
                                            }
                                        />
                                        <div
                                            className={`${styles.tooltipDiv} ${styles.pencilToolTip}`}
                                        >
                                            Edit CategoryName
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    }

                </div>
                <div className={styles.menuParentDiv}>
                    {samplesToShow.length > 0 && (
                        <div className={styles.imageCountDiv}>
                            <p style={{ marginBottom: '0' }}>
                                {samplesToShow.length}{' '}
                                {isAudioTrain ? 'Audio' : 'Image'} samples
                            </p>
                        </div>
                    )}
                    <div style={{ position: 'relative' }}>
                        <img
                            id={styles.uploadImg}
                            style={{ cursor: 'pointer' }}
                            src={renderPrgImage('photoUpload')}
                            alt="Upload"
                            width={isAudioTrain ? '30' : undefined}
                            onClick={() => {
                                if (isAudioTrain) {
                                    audioModelOpen({
                                        value: true,
                                        audioUpload: true,
                                        className: classesObjectKey,
                                    })
                                    setAudioUploadOpen(true)
                                } else {
                                    webCamModelOpen({
                                        value: true,
                                        imageUpload: true,
                                        classesObjectKey: classesObjectKey,
                                    })
                                }
                            }}
                        />
                        <div
                            className={`${styles.tooltipDiv} ${styles.uploadToolTip}`}
                        >
                            Upload
                        </div>
                    </div>
                    {isAudioTrain ? (
                        <div style={{ position: 'relative' }}>
                            <img
                                id={styles.webCamImg}
                                style={{ cursor: 'pointer' }}
                                src={renderPrgImage('teachableMachineMic')}
                                alt="Mic"
                                width="30"
                                onClick={() =>
                                    audioModelOpen({
                                        value: true,
                                        audioUpload: false,
                                        className: classesObjectKey,
                                    })
                                }
                            />
                            <div
                                className={`${styles.tooltipDiv} ${styles.webCamToolTip}`}
                            >
                                Record
                            </div>
                        </div>
                    ) : (
                        <div style={{ position: 'relative' }}>
                            <img
                                id={styles.webCamImg}
                                style={{ cursor: 'pointer' }}
                                src={renderPrgImage('webCam')}
                                alt="Webcam"
                                onClick={() =>
                                    webCamModelOpen({
                                        value: true,
                                        imageUpload: false,
                                        classesObjectKey: classesObjectKey,
                                    })
                                }
                            />
                            <div
                                className={`${styles.tooltipDiv} ${styles.webCamToolTip}`}
                            >
                                Webcam
                            </div>
                        </div>
                    )}
                    <div style={{ position: 'relative' }}>
                        <img
                            id={styles.deleteClassImg}
                            style={
                                isShowClassDeleteBtn && !isBgNoise
                                    ? { cursor: 'pointer' }
                                    : { cursor: 'default' }
                            }
                            src={
                                isShowClassDeleteBtn && !isBgNoise
                                    ? renderPrgImage('deleteEnable')
                                    : renderPrgImage('deletDisable')
                            }
                            alt="Delete class"
                            onClick={() => handleClassDelete()}
                        />
                        <div
                            className={`${styles.tooltipDiv} ${styles.deleteClassToolTip}`}
                        >
                            Delete class
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.trainClassBodyDiv}>
                <div className={styles.samplesDivParent}>
                    <div className={styles.samplesDiv} ref={containerRef}>
                        {samplesToShow.map((sample, index) => (
                            <div
                                key={sample.id || index}
                                className={styles.sampleImgDiv}
                            >
                                {isAudioTrain ? (
                                    <div
                                        style={{
                                            width: '70px',
                                            height: '70px',
                                            backgroundColor: '#fff',
                                            borderRadius: '5px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow:
                                                '0 2px 5px rgba(0,0,0,0.1)',
                                        }}
                                    >
                                        <SpectrogramThumbnail
                                            data={sample.sampleData}
                                        />
                                    </div>
                                ) : (
                                    <img
                                        src={sample.sampleData}
                                        width="70"
                                        height="70"
                                        alt={`Captured ${index}`}
                                        className={styles.sampleImage}
                                        style={{ borderRadius: '5px' }}
                                    />
                                )}
                                <img
                                    src={renderPrgImage('eachImgCross')}
                                    className={styles.imgDelete}
                                    id={styles.imgDelete}
                                    alt="delete each sample"
                                    onClick={() =>
                                        removeSingleSample(index, sample.id)
                                    }
                                />
                                <div
                                    className={`${styles.tooltipDiv} ${styles.imgDeleteToolTip} `}
                                >
                                    Delete sample
                                </div>
                            </div>
                        ))}
                    </div>

                <div style={{ position: 'relative' }}>
                    <img
                        width="35"
                        height="35"
                        id={styles.deleteAllImg}
                        style={
                            samplesToShow.length > 0
                                ? { cursor: 'pointer' }
                                : { cursor: 'default' }
                        }
                        src={
                            samplesToShow.length > 0
                                ? renderPrgImage('crossEnable')
                                : renderPrgImage('crossDisable')
                        }
                        alt="Delete all samples"
                        onClick={() => handleRemoveSamples()}
                    />
                    <div
                        className={`${styles.tooltipDiv} ${styles.deleteAllToolTip}`}
                    >
                        Delete all samples
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        appModeStorage: state.appModeStorage,
        camModels: state.appModeStorage.trainMachine.camModels,
        currentModelId: state.appModeStorage.trainMachine.currentModelId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeClasses: (data) => {
            dispatch({ type: 'CHANGE_CLASSES', payload: data })
        },
        setClasses: (data) => {
            dispatch({ type: 'ADD_CLASSES', payload: data })
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftTrainingClass)
